class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    document.addEventListener("click", function (e) {
      const cartNoteClose = e.target.closest(".cart-footer-notes-toggle");
      if (cartNoteClose) {
        CartDrawer.onCloseNotes(cartNoteClose);
      }

      const cartNoteOpen = e.target.closest("#Details-CartDrawer");
      if (cartNoteOpen) {
        cartNoteOpen.querySelector("textarea").dataset.currentValue = cartNoteOpen.querySelector("textarea").value;
      }
    });
  }

  static onCloseNotes(closeButton) {
    const detailsElement = closeButton.closest("details");
    const notesTextEl = detailsElement.querySelector("textarea");

    if (notesTextEl) {
      if (closeButton.classList.contains("cart-footer-notes-toggle--cancel")) {
        const oldContent = notesTextEl.dataset.currentValue;
        notesTextEl.value = oldContent;
      }

      const addEditLabels = document.querySelectorAll(".cart-note-text");
      // Updates the headings to add or edit based on notes content
      if (notesTextEl.value.length > 0) {
        addEditLabels.forEach((addEditLabel) => (addEditLabel.textContent = addEditLabel.dataset.edit));
      } else {
        addEditLabels.forEach((addEditLabel) => (addEditLabel.textContent = addEditLabel.dataset.add));
      }

      const cartNoteIconSwitchers = document.querySelectorAll(".cart-note--icon");
      cartNoteIconSwitchers.forEach((cartNoteIconSwitcher) => {
        if (notesTextEl.value.length > 0) {
          cartNoteIconSwitcher.classList.remove("cart-note--add");
          cartNoteIconSwitcher.classList.add("cart-note--edit");
        } else {
          cartNoteIconSwitcher.classList.add("cart-note--add");
          cartNoteIconSwitcher.classList.remove("cart-note--edit");
        }
      });
    }

    // close details
    detailsElement.open = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (window.location.pathname === '/cart') return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const sectionHtml = parsedState.sections ? parsedState.sections[section.id] : null;
      if (!sectionHtml) return;
      const newInnerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (newInnerHTML !== null) {
        sectionElement.innerHTML = newInnerHTML;
      }
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return null;
    const el = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
